import Inputmask from "inputmask";

window.Inputmask = Inputmask;
require("../v1/template/utility/float-input-labels");
require("../v1/template/app");
require("../v1/template/utility/country_phone_code");

const bindPasswordToggles = () => {
    document.querySelectorAll("[data-password-toggle]").forEach((button) => {
        if (button.dataset.bound === "1") {
            return;
        }

        button.dataset.bound = "1";
        button.addEventListener("click", () => {
            const wrap = button.closest(".v2-auth-field__password-wrap");
            const input = wrap?.querySelector("input");
            if (!input) {
                return;
            }

            const isHidden = input.type === "password";
            input.type = isHidden ? "text" : "password";

            button.querySelector('[data-password-state="hidden"]')?.toggleAttribute("hidden", !isHidden);
            button.querySelector('[data-password-state="shown"]')?.toggleAttribute("hidden", isHidden);
        });
    });
};

const bindSmsConfirm = () => {
    const form = document.getElementById("confirm-sms-form");
    const progress = document.getElementById("sms-progress");
    const sendCodeTitle = document.getElementById("send-code-title");
    const smsInput = form?.querySelector("input[name='sms']");
    const submitButton = form?.querySelector("[type='submit']");

    if (!form || !progress || !sendCodeTitle || !smsInput || !submitButton) {
        return;
    }

    const syncSubmitState = () => {
        const value = (smsInput.value || "").replace(/[^0-9]/g, "");
        submitButton.toggleAttribute("disabled", value.length !== 6);
    };

    smsInput.addEventListener("input", syncSubmitState);
    syncSubmitState();

    const setProgressWidth = (percentage) => {
        progress.style.width = `${Math.max(0, Math.min(100, percentage))}%`;
    };

    const renderCountdownMessage = (remaining) => {
        sendCodeTitle.textContent = "";
        sendCodeTitle.append(document.createTextNode(`${sendCodeTitle.getAttribute("data-send-cod-text")} `));

        const counter = document.createElement("b");
        counter.textContent = `${remaining}`;
        sendCodeTitle.append(counter);
    };

    const renderResendButton = () => {
        sendCodeTitle.textContent = "";

        const button = document.createElement("button");
        button.type = "button";
        button.className = "v2-auth-inline-action";
        button.dataset.resendCodeTrigger = "";
        button.textContent = sendCodeTitle.getAttribute("data-send-cod-text") || "";

        sendCodeTitle.append(button);
    };

    const resendCode = async () => {
        const route = progress.getAttribute("data-route");
        if (!route) {
            return;
        }

        try {
            const response = await fetch(route, {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.content || "",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: new FormData(form),
            });

            const data = await response.json();
            if (!data?.success) {
                return;
            }

            smsInput.value = "";
            syncSubmitState();

            setProgressWidth(100);
            progress.setAttribute("data-count-sec", data.countSec);
            enableProgress();
        } catch (error) {
            console.error(error);
        }
    };

    const enableProgress = () => {
        const totalSeconds = parseInt(progress.getAttribute("data-count-sec") || "0", 10);
        if (!totalSeconds) {
            renderResendButton();
            setProgressWidth(0);
            return;
        }

        let remaining = totalSeconds;
        clearInterval(window.__v2SmsProgressTimer);
        renderCountdownMessage(remaining);
        setProgressWidth(100);

        window.__v2SmsProgressTimer = window.setInterval(() => {
            remaining -= 1;
            setProgressWidth((remaining / totalSeconds) * 100);

            if (remaining <= 0) {
                clearInterval(window.__v2SmsProgressTimer);
                renderResendButton();
                setProgressWidth(0);
                return;
            }
            renderCountdownMessage(remaining);
        }, 1000);
    };

    sendCodeTitle.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-resend-code-trigger]");
        if (!trigger) {
            return;
        }

        event.preventDefault();
        resendCode();
    });

    enableProgress();
};

const buildV2PopupMultipleSelect = (select) => {
    if (typeof window.$ !== "function") {
        return;
    }

    const $select = select instanceof window.$ ? select : window.$(select);
    if (!$select.length) {
        return;
    }

    const next = $select.next(".material-select");
    if (next.length) {
        const modalId = next.attr("data-target");
        if (modalId) {
            window.$(modalId).remove();
        }

        next.remove();
    }

    const addSearch = !!$select.attr("data-show-search");
    const parent = $select.closest(".form-group");
    const placeholder = $select.find("option").eq(0).text();

    window.__v2ModalMultiSelectI = (window.__v2ModalMultiSelectI || 0) + 1;
    const id = `v2ModalMultiSelect_${window.__v2ModalMultiSelectI}`;
    const materialSelectId = `v2-material-popup-multi-select-${window.__v2ModalMultiSelectI}`;

    let selectModalHtml = `<div class="v2-modal v2-select-modal" id="${id}" tabindex="-1" aria-labelledby="${id}Label" aria-hidden="true" hidden>
        <div class="v2-modal__dialog v2-modal__dialog--md form v2-select-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="${id}Label">
            <div class="v2-modal__header">
                <button type="button" class="v2-modal__close close" data-modal-close aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h5 class="v2-modal__title modal-title" id="${id}Label">${window.$.trim(placeholder.replace("*", ""))}</h5>
                <button class="submit btn btn-outline-primary" data-modal-close aria-label="Close" type="button">Зберегти</button>
            </div>
            <div class="v2-modal__body modal-body">
                <div class="modal-select">`;

    if (addSearch) {
        selectModalHtml += `<div class="search v2-select-modal__search">
            <input id="input-label-search-${id}" name="search" value="" class="form-control" type="text" autocomplete="off" autofocus placeholder="Пошук">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="clear-svg search-ico" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
        </div>`;
    }

    const textValue = [];
    let eachI = 0;
    let textValueI = 0;
    const selectOptions = $select.find("option");
    const valSelectOptions = $select.find("option[value!='']");

    selectOptions.each(function() {
        const sel = window.$(this);
        const selVal = sel.val();
        const selText = window.$.trim(sel.text());
        const labelName = `${id}-modalMultiSelectLabel_${eachI}`;
        const selected = sel.is(":selected");

        if (selected) {
            textValue[textValueI++] = selText;
        }

        if (selVal) {
            selectModalHtml += `<label for="${labelName}" class="option custom-control custom-checkbox">
                <input ${selected ? "checked='checked'" : ""} value="${selVal}" name="${labelName}" type="checkbox" class="custom-control-input" id="${labelName}">
                <span class="custom-control-label">${selText}</span>
            </label>`;
        }

        eachI += 1;
    });

    selectModalHtml += "</div></div></div></div>";

    const selectModal = `<div data-modal-id="${id}" id="${materialSelectId}" class="form-group ${!valSelectOptions.length ? "no-vals" : ""} material-select has-float-label" data-toggle="${valSelectOptions.length ? "modal" : ""}" data-target="#${id}">
        <input readonly class="form-control" type="text" value="${textValue.length ? textValue.join(", ") : ""}" placeholder=" " />
        <label>${placeholder}</label>
    </div>`;

    parent.find(".form-control.modal-select").remove();
    $select.after(selectModal);
    $select.addClass("d-none");
    $select.removeAttr("disabled");
    window.$("#modals-wraper").append(selectModalHtml);

    const newModalEl = window.$(`#${id}`)[0];
    if (!newModalEl) {
        return;
    }

    newModalEl.addEventListener("shown.bs.modal", function(event) {
        const $trigger = window.$(event.relatedTarget);
        const targetSelect = $trigger.prev("select");
        const searchAutofocus = !!targetSelect.attr("data-search-autofocus");
        const $labels = window.$(newModalEl).find(".modal-select .option");
        const $optionElements = $labels.find("input[type='checkbox']");

        $optionElements.off("click");
        $optionElements.on("click", function(modalEvent) {
            modalEvent.stopPropagation();
            const checkbox = window.$(this);
            const option = targetSelect.find(`option[value='${checkbox.val()}']`);

            if (option.length) {
                if (checkbox.is(":checked")) {
                    option.attr("selected", "selected");
                } else {
                    option.removeAttr("selected");
                }
            }

            targetSelect.change();
        });

        const searchInput = window.$(newModalEl).find(".modal-select .search input");
        if (searchInput.length) {
            if (searchAutofocus) {
                searchInput.focus();
            }

            searchInput.off("change keyup input");
            searchInput.on("change keyup input", function() {
                const val = window.$.trim(window.$(this).val().toLowerCase());
                if (!val) {
                    $labels.show();
                    return;
                }

                $labels.each(function() {
                    const label = window.$(this);
                    const txt = window.$.trim(label.find(".custom-control-label").text()).toLowerCase();
                    label.toggle(txt.indexOf(val) >= 0);
                });
            });
        }
    });

    newModalEl.addEventListener("hide.bs.modal", () => {
        const selected = $select.find(":selected");
        const values = [];

        selected.each(function() {
            values.push(window.$.trim(window.$(this).text()));
        });

        window.$(`#${materialSelectId} input`).val(values.join(", "));
    });
};

const bindLegacyMaterialSelects = () => {
    if (typeof window.$ !== "function") {
        return;
    }

    const singleSelects = window.$("select.form-control.material").not("[multiple]");
    const multipleSelects = window.$("select.form-control.material[multiple]");

    if (typeof window.generatePopupSelect === "function") {
        singleSelects.each(function() {
            window.generatePopupSelect(window.$(this));
        });
    }

    multipleSelects.each(function() {
        const currentSelect = window.$(this);

        if (currentSelect.is("[data-popup-managed='external']")) {
            buildV2PopupMultipleSelect(currentSelect);
            return;
        }

        if (typeof window.generatePopupMultipleSelect === "function") {
            window.generatePopupMultipleSelect(currentSelect);
        }
    });
};

document.addEventListener("DOMContentLoaded", () => {
    bindPasswordToggles();
    bindSmsConfirm();
    bindLegacyMaterialSelects();
});
